<form [formGroup]="form()">
  <div class="grid">
    <div class="md:col-4">
      <label class="label">{{ translations.CLEANING }}</label>
      <wr-tenant-select formControlName="cleaningContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
    <div class="md:col-4">
      <label class="label">{{ translations.GREEN_AREA_MAINTENANCE }}</label>
      <wr-tenant-select formControlName="greenAreaMaintenanceContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
    <div class="md:col-4">
      <label class="label">{{ translations.WINTER_SERVICE }}</label>
      <wr-tenant-select formControlName="winterServiceContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
  </div>
</form>
